var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 59,
    viewBox: "0 0 45 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01426 8.67141C7.43192 8.02864 7.88801 7 8.75534 7H16.9117C17.1927 7 17.4608 7.11829 17.6503 7.32589L36.8961 28.414C37.2398 28.7905 37.2452 29.3653 36.9086 29.7482L17.6516 51.6601C17.4617 51.8762 17.188 52 16.9004 52H8.23575C7.37149 52 6.91421 50.9777 7.49032 50.3334L25.8999 29.7464C26.241 29.365 26.2391 28.7876 25.8955 28.4084L8.01426 8.67141Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_251_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.01426 8.67141C7.43192 8.02864 7.88801 7 8.75534 7H16.9117C17.1927 7 17.4608 7.11829 17.6503 7.32589L36.8961 28.414C37.2398 28.7905 37.2452 29.3653 36.9086 29.7482L17.6516 51.6601C17.4617 51.8762 17.188 52 16.9004 52H8.23575C7.37149 52 6.91421 50.9777 7.49032 50.3334L25.8999 29.7464C26.241 29.365 26.2391 28.7876 25.8955 28.4084L8.01426 8.67141Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_251_12",
    x: 0.233887,
    y: 0,
    width: 43.9238,
    height: 59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_251_12"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/right_arrow_icon.71ebba2546f1c05d904601acd9de211f.svg";
export { ForwardRef as ReactComponent };